export default {
  slots: {
    base: 'duration-300 transition disabled:opacity-50 cursor-pointer',
  },
  variants: {
    size: {
      xl: 'px-5 py-3 text-lg font-bold gap-2',
    },
  },
}